var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendarOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.389 14.869c.496 0 .903.402.903.893 0 .492-.407.894-.903.894-.497 0-.903-.402-.903-.893 0-.492.406-.894.903-.894zm7.222 0c.497 0 .903.402.903.893 0 .492-.406.894-.903.894H13c-.497 0-.903-.402-.903-.893 0-.492.406-.894.903-.894zm1.806 4.468H7.583c-.497 0-.902-.4-.902-.893V13.08h12.638v5.363c0 .492-.405.893-.902.893M7.583 6.825h.903v.894c0 .491.406.894.903.894.496 0 .903-.403.903-.894v-.894h5.416v.894c0 .491.407.894.903.894.497 0 .903-.403.903-.894v-.894h.903c.497 0 .902.401.902.894v3.575H6.681V7.719c0-.493.405-.894.902-.894m10.834-1.788h-.903v-.893c0-.492-.406-.894-.903-.894-.496 0-.903.402-.903.894v.893h-5.416v-.893c0-.492-.407-.894-.903-.894-.497 0-.903.402-.903.894v.893h-.903c-1.493 0-2.708 1.203-2.708 2.682v10.725c0 1.478 1.215 2.681 2.708 2.681h10.834c1.493 0 2.708-1.203 2.708-2.681V7.719c0-1.479-1.215-2.682-2.708-2.682",
    transform: "translate(-250 -28) translate(-33) translate(283 28)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarOrange);
export default __webpack_public_path__ + "static/media/icon-calendar--orange.7603e46f8f1daaae50948078264048ac.svg";
export { ForwardRef as ReactComponent };